import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "rounded-lg border border-white px-4 py-2 flex flex-col space-y-4" }
const _hoisted_2 = { class: "flex flex-row justify-center items-center space-x-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-2" }, null, -1)

import { computed, ComputedRef } from "vue";
import Timer from "@/Interfaces/Timer";
import ModalText from "@/components/Texts/ModalText.vue";
import { useGameStore } from "@/Store/useGameStore";
import { Action } from "@/Interfaces/Action";

export default /*#__PURE__*/_defineComponent({
  __name: 'TimerModalElements',
  props: {
    timer: {},
    index: {}
  },
  setup(__props: any) {

/* Inspiré de : https://play.vuejs.org/#eNp9UstOwzAQ/BXjCyDRBKniUtKKh3qAAyDo0ZfgblO3jm3Zm7RV1X9nHUelSKineGdnxrMb7/mjc1nbAB/xIkivHLIA2LiJMKp21iPbMw8LdmALb2t2SdRLYYSR1gSiLu2GjSPhCn0D18IUeXIhPRUItdMlAlWMFd8NojXsQWol12PBe/VF/Ao+mdmq0lDkiZYkM1+aoFD1NSGOtQO16NWkWoLWtshjYOrmfwRFfhKAyoA7HY9ZOwCD4AelRNXCTYdoKFvoEbaPbnj0GjHrSqlwx26zu8CgDHAvzCGaHr3ifk6d0CaXXjlit0lCG+pi8BuOgda4UFW2CtbQH+j4gktbO6XBv7t4dxB8lJxir6RpN68dFjdOFyZcLkGu/8FXYRsxwT88BPAtCH7sYekrwNSefr3Bls7HZm3njSb2meYnBKubmDHRnhozp9gnvC7tS/eOlKlmYbpFoJX2Q8WgkXno+ILT23o+M/pv3GE27HS0T374AbBs70k= */

const gameStore = useGameStore();

const props = __props;

const gameActions: ComputedRef<Action[]> = computed(() => {
  return gameStore.gameActions;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ModalText, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(gameStore).secondsToMinutesAndSeconds(props.timer.time_left)), 1)
        ]),
        _: 1
      }),
      (!props.timer.started && props.timer.time_left > 0)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(gameStore).startTimer(props.index))),
            class: "bi bi-play text-green-500"
          }))
        : _createCommentVNode("", true),
      (props.timer.started)
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(gameStore).pauseTimer(props.index))),
            class: "bi bi-pause text-yellow-500"
          }))
        : _createCommentVNode("", true),
      (
          props.timer.started ||
          props.timer.time_left === 0 ||
          (!props.timer.started &&
            props.timer.time_left !== props.timer.time_full)
        )
        ? (_openBlock(), _createElementBlock("i", {
            key: 2,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(gameStore).restartTimer(props.index))),
            class: "bi bi-arrow-repeat text-blue-500"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("i", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(gameStore).stopTimer(props.index))),
        class: "bi bi-x text-red-500"
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(ModalText, null, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(gameActions.value[props.timer.action_id].description), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})